import { mount } from 'svelte';
import App from './App.svelte';
import './app.css';

const target = document.getElementById('app');
if (!target) throw new Error('No #app element found');

mount(App, { target });

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  // Register with `onNeedRefresh` auto-reloading — combined with the workbox
  // `skipWaiting` + `clientsClaim` config this makes deploys propagate within
  // one page load instead of waiting for every tab to close.
  import('virtual:pwa-register').then(({ registerSW }) => {
    const updateSW = registerSW({
      immediate: true,
      onNeedRefresh() {
        // A new SW is waiting — tell it to activate and force a reload.
        updateSW(true);
      },
    });
  });
}
